//#region
import axios from 'axios'
import { url, endPoint } from '../urls'
//#endregion

export const addDataSource = (params) => {
  let _url = url.backendHost + endPoint.dataSource.addDataSource
  return axios.post(_url, params)
}

export const getDataSource = (params) => {
  let _url = url.backendHost + endPoint.dataSource.getDataSource
  return axios.get(_url, { params })
}

export const updateDataSource = (params) => {
  let _url = url.backendHost + endPoint.dataSource.updateDataSource
  return axios.put(_url,  params )
}
export const deleteDataSource = (params) => {
  let _url = url.backendHost + endPoint.dataSource.deleteDataSource
  return axios.put(_url,  params )
}
export const updateActivationStatus = (params) => {
   let _url = url.backendHost + endPoint.dataSource.updateActivationStatus
   return axios.put(_url,  params )
}
 